module.exports = __webpack_public_path__ + "static/media/kangaroo.a3a9d622.gif";